<template>
  <div class="page_content module_assessment" :class="addPrintClass()">

    <div class="row" v-if="isStudentLogin" :key="uuid">
      <div class="col-12">
        <!--
        <div class="max-attempt-row">
          <span><span class="ace_sec_txt" style="color: #949494;">Max Attempts</span> <strong style="font-size: 14px;">{{assessment.maxAttempt}}</strong></span> | <span><span class="ace_sec_txt" style="color: #949494;"> Attempts Remaining</span> <strong style="font-size: 14px;">{{attemptsRemaining}}</strong></span>
        </div>
        -->
        <!--
        <div v-if="isShowActivityOutcome && !assessment.isResume">
          <div class="result_summary">
            <div class="float-right" style="margin-top: 8px;">
              <span class="answered ace_sec_txt">question attempted {{ attempt.questionAttempted }}/{{ attempt.questionCount }}</span>
            </div>
            <template v-if="attempt.manualGradingRequired && !attempt.manuallyGraded" style="margin-bottom: 30px;">
              <div class="msg">
                <span class="icon-warning"></span>
                <span class="ace_sec_txt">Assessment is submitted and grades will be available once instructor completes grading. Meanwhile, you can continue to use other learning resources.</span>
              </div>
            </template>
            <template v-else>
              <div style="height: 30px;" class="result-row mb-4">
                <span class="float-left">
                  <span class="progress_block" style="float: left; margin-top: 6px; margin-right: 10px;">
                    <span class="state" :class="statusClass">
                      <span class="progress_val ace_sec_txt">{{ performance }}%</span>
                    </span>
                  </span>
                  <span class="score ace_sec_txt">{{ attempt.score }}/{{ attempt.maxScore }}</span>
                  <span class="score_txt ace_sec_txt">correct</span>
                </span>
              </div>
              <div v-if="statusClass === 'gradeA' || statusClass === 'gradeB'" class="text-justify ace_sec_txt">
                Well done! You’ve successfully learnt <i>{{ assessment.title }}</i>. <br/>
                <span v-if="course.courseType === 'RICH_HTML_SUPPORT'" class="ace_sec_txt">
                To continue learning the next micro-competency, click “Start Learning” on the right.
                </span>
                <span v-if="course.courseType === 'SUGGESTION_PLUS_BASED'" class="ace_sec_txt">
                  Click “Check Your Knowledge” on the right to move to the next micro competency.
                  <br/>
                  Alternatively, here are some learning resources that you may find interesting.
                  <br/>
                  <b-button :to="{ name: 'entityDetail', params: { uuid: courseId, entityType: 'LearningContent', entityUuid: uuid } }" variant="primary" class="btn additional-btn">Additional Resources</b-button>
                </span>
              </div>
              <div v-if="statusClass === 'gradeC' || statusClass === 'gradeD' || statusClass === 'gradeE'" class="text-justify ace_sec_txt">
                You got {{ attempt.score }} out of {{ attempt.maxScore }} right. <br/>
                <template v-if="course.courseType === 'RICH_HTML_SUPPORT'">
                  <span v-if="attemptsRemaining > 0" class="ace_sec_txt">
                  Study material that will help you understand the concepts of this micro-competency better can be accessed from the TOC. You still have {{ attemptsRemaining }} attempt left.
                  <br/>
                  To re-take the Knowledge Check, click on “Check Your Knowledge” button below. If you would like to start learning the next micro-competency, click “Start Learning” on the right.
                  </span>
                  <span v-else class="ace_sec_txt">
                  You have completed all attempts. The study material for this micro-competency can be accessed from the TOC at any time.
                  <br/>
                  To continue learning the next micro-competency, click “Start Learning” on the right.
                  </span>
                </template>
                <template v-else>
                  <span v-if="parentCompetency.status < 2" class="ace_sec_txt">
                  Here is some study material that will help you understand the concepts of this micro competency better. Click “Start Learning” on the right.
                  </span>
                </template>
                <span v-if="course.courseType === 'SUGGESTION_PLUS_BASED' && parentCompetency.status >1 ">
                  <br/>
                  <span v-if="assessment.orderId !== '3'" class="ace_sec_txt"><strong>
                  You can improve your score by attempting the remaining Knowledge Check : KC3</strong>
                  <br/><br/>
                  </span>
                  Here are some learning resources that you may find interesting. Alternatively, you can continue with the course by clicking “Check Knowledge” on the right.
                  <br/>
                  <b-button :to="{ name: 'entityDetail', params: { uuid: courseId, entityType: 'LearningContent', entityUuid: uuid } }" variant="primary" class="btn additional-btn">Additional Resources</b-button>
                </span>
              </div>
            </template>
          </div>
        </div>
        -->
        <div class="row attempts_summary" v-if="myattempts.length > 0">
          <div class="col-12 KC_results_sec">
            <!-- Show all attempts -->
            <div class="row section_head ace_sec_txt">
              <div class="col-8">
                <span v-if="assessment.diagonesticTest || assessment.diagonesticReportTest">
                  {{ $tf('diagnosticTestResults') }}
                </span>
                <span v-if="!assessment.diagonesticTest && !assessment.diagonesticReportTest">
                {{ $tf('knowledgeCheckResults') }}
                </span>
              </div>
              <div class="col-4 btn_container" v-if="isShowCheckKnowledgeButton">
                <b-button variant="primary" v-if="!assessment.isResume" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickCheckKnowledge'} }" class="btn btn-lg btn_no_bg">
                  {{ $tf('takeKCAgain') }}
                </b-button>
              </div>
            </div>
            <table class="attempts_summary_table">
              <div class="row kc_result_row" v-for="(myattempt, index) in myattempts" :class="gradeStatus1(myattempt.score, myattempt.maxScore)">
                <div class="col-12">

                  <div class="row">
                    <div class="col-4 ace_sec_txt report_col">
                      {{ $tf('attempt') }}
                      {{index + 1}}
                      {{ $tf('of') }}
                      {{assessment.maxAttempt}}
                    </div>
                    <div class="col-4 ace_sec_txt report_col sec_date">
                      <span class="ic ic9-timetable"></span>
                      <span class="sec_txt_time">{{getFormattedDateTime(myattempt.startTime)}}</span>
                    </div>
                    <div class="col-4 report_col">
                      <div class="sec_txt_score" :class="gradeStatus1(myattempt.score, myattempt.maxScore)">
                        <div v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)">
                          <!--
                          <span class="icon_success ace_sec_txt" :id="'stat_' + index" :class="gradeStatus1(myattempt.score, myattempt.maxScore)"></span>
                          -->
                          <span class="txt" style="pt-1">{{myattempt.score}} / {{myattempt.maxScore}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                        <div v-else>
                          <span class="icon_success noGrade ace_sec_txt" :id="'stat_' + index"></span>
                          <span class="sec_txt_score noGrade">{{myattempt.score}} / {{myattempt.maxScore}}</span>
                        </div>
                      </div>
                    </div>
                    <template v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)" @click="showLearnosityReport(myattempt, myattempt.activityId, myattempt.sessionId)">
                    </template>
                    <template v-else>
                      <div class="col-4 report_col">
                        <span class="ace_sec_txt">
                          {{ $tf('gradePending') }}
                        </span>
                      </div>
                    </template>

                  </div>

                  <div class="row btn_container">
                    <div class="col-12 btn_container_inner">
                      <template v-if="myattempt.isResume && ((!myattempt.manualGradingRequired) || (myattempt.manualGradingRequired && myattempt.manuallyGraded))">
                          <template v-if="!assessment.diagonesticReportTest && !assessment.diagonesticTest && !assessment.localPractice">
                            <b-link variant="primary" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_wt">
                              resume knowledge check
                            </b-link>
                          </template>
                          <template v-if="assessment.diagonesticTest">
                            <b-link variant="primary" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_wt">
                              resume pre-diagnostic
                            </b-link>
                          </template>
                          <template v-if="assessment.diagonesticReportTest">
                            <b-link variant="primary" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_wt">
                              resume post-diagnostic
                            </b-link>
                          </template>
                          <template v-if="assessment.localPractice">
                            <b-link variant="primary" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_wt">
                              resume practice pest
                            </b-link>
                          </template>
                      </template>
                      <template v-else>
                        <b-btn variant="primary" class="btn btn_wt" v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)" @click="showLearnosityReport(myattempt, myattempt.activityId, myattempt.sessionId)">
                          {{ $tf('showReport') }}
                        </b-btn>
                        <b-btn variant="primary" class="target_btn btn btn_wt" @click="showAttemptAI(myattempt, myattempt.activityId, myattempt.sessionId)" v-if="isAIAnswerAnalysisEnabled">
                          <span class="txt">  {{ $tf('aiAnswerAnalysis') }}  </span>
                          <span class="anchor" id="pragyaGuideDisplayBtn">.</span>
                        </b-btn>
                        <b-btn class="btn btn_wt" v-if="(assessment.diagonesticTest || assessment.diagonesticReportTest)" @click="showDiagnosticTestReport">competency breakdown report</b-btn>

                        <template v-if="isAIAnswerAnalysisEnabled">
                          <div id="pragyaAIButtonPopoverContainer2" class="popover_container_v4 no_header pragya_guide_container pragya_guide_v2"></div>
                          <template>
                            <b-popover ref="pragyaAiButtonModal" :show.sync="pragyaGuideModal__Ai" target="pragyaGuideDisplayBtn" triggers="click" show="true" placement="right" container="pragyaAIButtonPopoverContainer2" custom-class="popover_v4">
                              <div class="close_btn_container">
                                <b-btn class="btn_close btn_clr_2" @click="closePragyaGuideModal">
                                  <span class="ic-close"></span>
                                </b-btn>
                              </div>
                                <div class="row">
                                  <div class="col-12 mb-3">
                                    {{ $tf('aiAnswerAnalysisPopupMsg') }}
                                  </div>
                                </div>

                                <!--
                                <div class="row btn_container">
                                  <div class="col-6 left">
                                    <b-btn class="btn btn_clr_2" @click="closePragyaGuideModal">
                                      not now
                                    </b-btn>
                                  </div>
                                  <div class="col-6 right">
                                    <b-btn class="btn" @click="showAttemptAI(myattempt, myattempt.activityId, myattempt.sessionId)">
                                      show me
                                    </b-btn>
                                  </div>
                                </div>
                                -->

                                <div class="row actions mt-0">
                                  <div class="col-12 hide_tour_check">
                                    <input type="checkbox" v-model="isDoNotOpenGuide" id="hideApplicationTour">
                                    <label for="hideApplicationTour">
                                      {{ $tf('dontShowAgainMsg') }}
                                    </label>
                                  </div>
                                </div>
                              </b-popover>
                            </template>
                          </template>

                      </template>
                    </div>
                  </div>

                </div>
              </div>
            </table>
          </div>
        </div>
        <div v-if="isShowCheckKnowledgeButton && myattempts.length === 0">
          <div v-if="!assessment.isResume && isDescriptionReady" class="entity_desc">
          <template v-if="assessment.localPractice || assessment.diagonesticReportTest || assessment.diagonesticTest ">
              <template v-if="institution.overrideAssessmentDescription">
                <span v-html="configuredDesc"></span>
              </template>
              <template v-else>
                <template v-if="assessment.description">
                  <span v-html="assessment.description"></span>
                </template>
                <template v-else>
                  <span v-html="configuredDesc"></span>
                </template>
              </template>
            </template>
          <template v-else>
              <template v-if="institution.overrideAssessmentDescription">
                <span v-html="configuredCnowledgeCheckDescription"></span>
              </template>
              <template v-else>
                <template v-if="assessment.description">
                  <span v-html="assessment.description"></span>
                </template>
                <template v-else>
                  <span v-html="configuredCnowledgeCheckDescription"></span>
                </template>
              </template>
            </template>
            <!--
            <p v-if="showDescription" class="ace_sec_txt">
              This micro-competency in this course is related to understanding  <i>{{ assessment.title }}</i>.
              Before we begin teaching, we need to determine your level of understanding of this concept with a <i>Knowledge Check</i>, so we know how to guide your learning.
              <br/>
              The results of this check do not reflect on your grade, it simply guides the learning process. If you assess above a certain threshold (80%),
              you are automatically advanced to the next micro-competency, and are not required to engage in further learning activities for this concept.
              If you assess below 80%, you will be offered a learning resource to study in order to increase your knowledge in this area.
            </p>
            <p v-else class="ace_sec_txt">
              This micro-competency in this course is related to understanding <i>{{assessment.title}}</i>. Study material that will help you understand the concepts of this micro-competency better can be accessed from the TOC. This Knowledge Check helps determine your level of understanding of this micro-competency.
              <br/>
              The results of this check do not reflect on your grade, it simply guides the learning process. If you assess above a certain threshold (80%), you are automatically advanced to the next micro-competency, and are not required to engage in further learning activities for this concept. If you assess below 80%, you will have 2 more attempts to re-take this knowledge check.
            </p>
            <p>Please click the button below to start the <i>Knowledge Check</i></p>
            -->
          </div>
          <div>
          <template v-if="!assessment.diagonesticReportTest && !assessment.diagonesticTest && !assessment.localPractice">
            <b-button variant="primary" size="lg" v-if="!assessment.isResume" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickCheckKnowledge'} }" class="btn_lg">Check Your Knowledge</b-button>
            <b-button variant="primary" size="lg" v-else :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_lg">Resume Knowledge Check</b-button>
          </template>
          <template v-if="assessment.diagonesticTest">
            <b-button variant="primary" size="lg" v-if="!assessment.isResume" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickCheckKnowledge'} }" class="btn_lg">Start Pre-Diagnostic </b-button>
            <b-button variant="primary" size="lg" v-else :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_lg">Resume Pre-Diagnostic </b-button>
          </template>
          <template v-if="assessment.diagonesticReportTest">
            <b-button variant="primary" size="lg" v-if="!assessment.isResume" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickCheckKnowledge'} }" class="btn_lg">Start Post-Diagnostic </b-button>
            <b-button variant="primary" size="lg" v-else :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_lg">Resume Post-Diagnostic</b-button>
          </template>
          <template v-if="assessment.localPractice">
            <b-button variant="primary" size="lg" v-if="!assessment.isResume" :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickCheckKnowledge'} }" class="btn_lg">Start Practice Test</b-button>
            <b-button variant="primary" size="lg" v-else :to="{ name: 'assessmentLearn', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId, action: 'clickResumeCheckKnowledge'} }" class="btn_lg">Resume Practice Test</b-button>
          </template>

          </div>

        </div>
        <b-modal id="aiAttemptModalContainer" class="full_screen_modal modal__v24" ref="aiAttemptModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="header-section">
            <div class="hd_ic">
              <span class="ic ic24-ai"></span>
            </div>
            <div class="hd_txt">
              {{ aiResorce.title }}
            </div>
            <div class="btn_container">
              <button
                class="btn_close"
                @click="closeaiAttemptModal"
                :aria-label="$tf('close')"
                :title="$tf('close')"
                v-b-tooltip.hover>
                  <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="rich-html-container-parent">
            <div v-if="!aiResorce.htmlBody">
              Pragya AI is analyzing your answers. It will only take a few seconds. Please wait...

              <div class="loader_container">
                <div class="loader_v24">
                  <stretch></stretch>
                </div>
              </div>
            </div>
            <div v-else v-html="aiResorce.htmlBody" class="ai_resource_container">
            </div>
          </div>
        </b-modal>

        <b-modal ref="attemptReportInfo" size="lg" centered  @hidden="isShowAttemptReport = false" hide-footer class="learnosity-report-modal">
          <template v-if="isShowAttemptReport">
            <div slot="modal-header" class="header-section">
              <div class="float-right">
                <button type="button" aria-label="Close" class="attempt-report-close" @click="closeAttemptReport">x</button>
              </div>
            </div>
            <div class="popup_inner_content">
              <span class="learnosity-report" id="sessionDetailByItemReport"></span>
            </div>
          </template>
        </b-modal>

        <b-modal id="diagnosticReportModal" ref="diagnosticTestReportInfo" size="lg" centered  @hidden="isShowDiagnosticTestReport = false" hide-footer class="learnosity-report-modal">
          <template v-if="isShowDiagnosticTestReport">
            <div slot="modal-header" class="header-section">
              {{diagnosticTestReport.userName}} - Diagnostic Test [{{assessment.title}}] Results - Attempt on {{diagnosticTestReport.testDate}}
              <div class="float-right">
                <button type="button" aria-label="Close" class="attempt-report-close" @click="closeDiagnosticTestReport">x</button>
                <button type="button" aria-label="Print" class="attempt-report-close" @click="printDiagnosticTestReport">print</button>
              </div>
            </div>
            <div class="popup_inner_content">
              <div class="course_name">
                {{diagnosticTestReport.course}} <img width=300 height=40 :src="institution.logo" align=right v-if="institution.logo" ></img>
              </div>
              <table class="table report_table">
                <thead>
                  <tr>
                    <th>Topic</th>
                    <th>Score</th>
                    <th>Performance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="module in diagnosticTestReport.modules">
                    <td>{{module.competencyName}}</td>
                    <td>
                      <template v-if="module.performance >= 90">
                        <div class="sec_txt_score gradeA">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 80 && module.performance < 90">
                        <div class="sec_txt_score gradeB">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 65 && module.performance < 80">
                        <div class="sec_txt_score gradeC">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 40 && module.performance < 65">
                        <div class="sec_txt_score gradeD">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance < 40">
                        <div class="sec_txt_score gradeE">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                    </td>
                    <td>
                      <template v-if="module.performance >= 90">
                        <div class="performance_bx gradeA">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 80 && module.performance < 90">
                        <div class="performance_bx gradeB">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 65 && module.performance < 80">
                        <div class="performance_bx gradeC">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 40 && module.performance < 65">
                        <div class="performance_bx gradeD">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance < 40">
                        <div class="performance_bx gradeE">{{module.performance}}%</div>
                      </template>
                    </td>
                    <td>{{module.status}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-if="!isShowDiagnosticTestReport">
            <stretch></stretch>
          </template>
        </b-modal>

      </div>
    </div>

    <!-- Intructor View -->
    <div v-else>
      <div class="row page-heading border-0">
        <div class="col-8 input module_heading">
          <span class="icon-assessment float-left"></span>
          <span class="head_txt ace_sec_txt">{{ assessment.title }}</span>
        </div>
        <div class="col-4 submit btn-container text-right">
          <button class="btn btn-primary" type="submit" @click="navigateToEdit" aria-label="edit">edit</button>
          <button class="btn btn-primary" type="submit" @click="navigateToResult" aria-label="back">back</button>
        </div>
      </div>
      <div class="row assessment-section mb-5">
        <div class="col-8 assessment-left-section">
          <div class="page-section">
            <div class="page_section_row input">
              <div class="heading border-0">
                <label for="description" class="ace_sec_txt">Assessment Description</label>
              </div>
              <div class="description-text ml-3 ace_sec_txt">{{ assessment.description }}</div>
            </div>
            <div class="page_section_row input mb-4 row">
              <div class="max-attempts col-6">
                <div class="heading border-0">
                  <label for="maxAttempt" class="ace_sec_txt">Maximum # of Attempts</label>
                </div>
                <div class="value ace_sec_txt">{{ assessment.maxAttempt }}</div>
              </div>
              <div class="max-attempts col-6">
                <div class="heading border-0">
                  <label for="folder" class="ace_sec_txt">Folder</label>
                </div>
                <div class="value folder-name ace_sec_txt">{{ assessment.ancestorName }}</div>
              </div>
            </div>
            <div class="page_section_row input mb-4 row">
              <div class="max-attempts col-12">
                <div class="heading border-0">
                  <label for="manualGradingRubric" class="ace_sec_txt">Manual Grading Instruction Document URL</label>
                </div>
                <div class="value url pl-0" style="width: calc(100% - 40px);">
                  <input
                    type="text"
                    id="manualGradingRubricPdfUri"
                    placeholder="http://"
                    :value="assessment.manualGradingRubricPdfUri"
                    :disabled="true">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 assessment-right-section">
          <div class="page_section_row">
            <div class="heading">
              <span class="ic-tag general mr-2"></span>
              <span class="ace_sec_txt">Assessment Tags</span>
            </div>
            <div class="value">
              <div class="tag-box-list" style="height: 102px; overflow: scroll !important;">
                <template v-for="(values, key, i) in appliedTagMap" class="tags_container">
                  <span class="tag" v-for="(tag, j) in values">
                  <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12" id="learnosity-author"></div>
      </div>

      <div class="assessment-creation-popup" v-if="isCreated">
        <b-modal ref="createSuccessModal" size="lg" :title="'1 assessment created'" :header-bg-variant="'create-asset-success-modal'" ok-disabled cancel-diasbled hide-header-close hide-footer no-close-on-backdrop no-close-on-esc centered>
          <div>
            <div>
              <span style="float: left; text-align: right;">
              Click if you have finished creating assessment
              </span>
              <span style="float: left; text-align: left;">
                <b-button @click="closeAndRedirect" class="btn button-primary ml-4"> ok </b-button>
              </span>
            </div>
            <div class="mt-1"></div>
            <div style="float: left; width: 100%; margin-top: 20px;">
              <span style="float: left; text-align: right;">
              Click if you want to create more assessment
              </span>
              <span style="float: left; text-align: left;">
                <b-button @click="showCreate" class="btn button-primary continue" aria-label="continue creating assessment"> continue creating assessment </b-button>
              </span>
            </div>
          </div>
        </b-modal>
      </div>

    </div>

    <div class="print_msg">
      Print is not available
    </div>

  </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import { mapState, mapActions } from 'vuex'
  import { Stretch } from 'vue-loading-spinner'
  import '../../../assets/module/less/create_entity.less'
  export default {
    name: 'assessmentDetail',
    props: ['uuid', 'courseId', 'isCreated', 'doNotShowOutcome'],
    components: {
			Stretch
		},
    data () {
      return {
        attempt: {},
        myattempts: [],
        assessment: {},
        aiResorce : {},
        courseCompetency: {},
        parentCompetency: {},
        isDescriptionReady: false,
        isShowReportButton: false,
        isShowAttemptReport: false,
        isStudentLogin: (localStorage.getItem('userrole') === 'Student'),
        entityType: 'LearningContent',
        appliedTagMap: {},
        status_css: {
          10: 'noGrade',
          0: 'gradeE',
          1: 'gradeD',
          2: 'gradeC',
          3: 'gradeB',
          4: 'gradeA'
        },
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        configuredCnowledgeCheckDescription: '',
        diagnosticTestReport: {},
        isShowDiagnosticTestReport: false
      }
    },
    computed: {
      ...mapState({
        'course': state => state.course.course,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'institution': state => state.institution.institution
      }),
      attemptsRemaining: function () {
        if (this.assessment && this.myattempts) {
          return this.assessment.maxAttempt - this.myattempts.length
        } else {
          return 0
        }
      },
      isShowCheckKnowledgeButton: function () {
        return this.isStudentLogin && this.assessment.isAttemptRemaining
      },
      showDescription: function () {
        if (this.course.courseType.startsWith('SUGGESTION')) {
          return true
        } else {
          return false
        }
      },
      isShowActivityOutcome: function () {
        if (this.doNotShowOutcome !== undefined) {
          return !this.doNotShowOutcome
        } else {
          const isAttempted = (this.attempt && this.attempt.maxScore)
          return (isAttempted !== undefined)
        }
        /*
        console.log('Path:', this.$router.app._route.name)
        if (this.$router.app._route.name === 'entityResult') {
          console.log('got in here')
          return true
        } else {
          return false
        } */
      },
      performance: function () {
        const score = this.courseCompetency.performance
        return (score) ? score.toFixed(2) : '0.00'
      },
      isAIAnswerAnalysisEnabled (){
        let contentToolsFeature = this.enabledFeatures['KC Tools']
        if (contentToolsFeature) {
          let flags = contentToolsFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'KC Learner Answer Analysis') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      statusClass: function () {
        var status = 10
        var performance = 0
        if (this.courseCompetency) {
          performance = this.courseCompetency.performance
          if (performance !== null) {
            if (performance >= 90) {
              status = 4
              $('.header-view, .psuedo-selector').addClass('gradeA')
            } else if (performance >= 80 && performance < 90) {
              status = 3
              $('.header-view, .psuedo-selector').addClass('gradeB')
            } else if (performance >= 65 && performance < 80) {
              status = 2
              $('.header-view, .psuedo-selector').addClass('gradeC')
            } else if (performance >= 40 && performance < 65) {
              status = 1
              $('.header-view, .psuedo-selector').addClass('gradeD')
            } else if (performance < 40) {
              status = 0
              $('.header-view, .psuedo-selector').addClass('gradeE')
            }
          } else {
            status = 10
            $('.header-view, .psuedo-selector').addClass('noGrade')
          }
        }
        return this.status_css[status]
      },
      configuredDesc () {
        var configDesc = ''
        if(this.assessment.localPractice){
          configDesc =  this.institution.praticeTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        if(this.assessment.diagonesticTest){
          configDesc =  this.institution.preDiagnosticTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        if(this.assessment.diagonesticReportTest){
          configDesc =  this.institution.postDiagnosticTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        return configDesc?configDesc:this.institution.knowledgeCheckDescription.replace('KC_TITLE', this.assessment.ancestorName)
      },

    },
    watch: {
      uuid () {
        this.loadAssessmentDetail()
      }
    },
    mounted () {
      this.loadAssessmentDetail()
    },
    methods: {
      ...mapActions([
        'loadCourseCompetencies',
        'loadAssessment2',
        'showAttemptReport',
        'launchManuallyGradedReportWizardForUser',
        'loadLogDashboardActivity',
        'loadKCDescription',
        'loadDiagnosticTestReport',
        'showAttemptAIReport',
        'loadAIResource'

      ]),
      getFormattedDateTime (timeInMillis, showOnlyDate) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        if (!showOnlyDate) {
          var amPm = ''
          var currHour = d.getHours()
          if (currHour < 12) {
            amPm = 'AM'
          } else {
            amPm = 'PM'
          }
          if (currHour === 0) {
            currHour = 12
          }
          if (currHour > 12) {
            currHour = currHour - 12
          }
          var currMin = d.getMinutes()
          currMin = currMin + ''
          if (currMin.length === 1) {
            currMin = '0' + currMin
          }
          var currSec = d.getSeconds()
          currSec = currSec + ''
          if (currSec.length === 1) {
            currSec = '0' + currSec
          }
          str += ' ' + currHour
          str += ':' + currMin
          str += ':' + currSec
          str += ' ' + amPm
        }
        return str
      },
      gradeStatus1 (minscore, maxscore) {
        let gradeClass = 'noGrade'
        let performance = parseFloat((minscore / maxscore) * 100).toFixed(2)
        if (performance >= 90) {
          gradeClass = 'gradeA'
        } else if (performance >= 80 && performance < 90) {
          gradeClass = 'gradeB'
        } else if (performance >= 65 && performance < 80) {
          gradeClass = 'gradeC'
        } else if (performance >= 40 && performance < 65) {
          gradeClass = 'gradeD'
        } else if (performance < 40) {
          gradeClass = 'gradeE'
        }
        return gradeClass
      },
      async loadAssessmentDetail () {
        if (this.courseId) {
          let res = await this.loadCourseCompetencies({courseId: this.courseId, loadDataFromServer: true})
          if (res && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              let competency = res[i]
              if (competency && (competency.entityId === this.uuid)) {
                this.courseCompetency = competency
                break
              }
            }
            for (var j = 0; j < res.length; j++) {
              let competency = res[j]
              if (competency && this.courseCompetency.parentCompetencyId === competency.competencyId) {
                this.parentCompetency = competency
                break
              }
            }
          }
        }
        let response = await this.loadAssessment2({uuid: this.uuid})
        const data = { ...response }
        this.myattempts = data.attempt
        if (this.myattempts && this.myattempts.length > 0) {
          this.attempt = this.myattempts[this.myattempts.length - 1]
        }
        this.assessment = data.assessment

        if (this.assessment.appliedTagMap) {
          this.appliedTagMap = this.assessment.appliedTagMap
        }
        if (this.isCreated) {
          this.$refs.createSuccessModal.show()
        }

        this.configuredCnowledgeCheckDescription = await this.loadKCDescription({entityId: this.uuid, courseType: this.course.courseType, courseId: this.course.uuid})
        if (this.configuredCnowledgeCheckDescription === '') {
          this.configuredCnowledgeCheckDescription = this.institution.knowledgeCheckDescription.replace('KC_TITLE', this.assessment.ancestorName)
        }

        this.isDescriptionReady = true

      },
      closeAttemptReport () {
        this.$refs.attemptReportInfo.hide()
      },
      showLearnosityReport (myattempt, activityId, sessionId, isManuallyGraded) {
        this.loadLogDashboardActivity({action: 'clickKnowlegdeCheckReport', page: 'courseLearn', link: '', entityUuid: this.courseId})
        this.attempt = myattempt
        this.isShowAttemptReport = true
        this.$refs.attemptReportInfo.show()
        this.showAttemptReport({activityId: activityId, sessionId: sessionId, courseId: this.courseId}).then(data => {
          if (data) {
            this.initializeLearnosityReports(data)
          }
        })
      },
      showAttemptAI (myattempt, activityId, sessionId, isManuallyGraded) {
        this.$refs.aiAttemptModal.show()
        this.showAttemptAIReport({activityId: activityId, sessionId: sessionId, courseId: this.courseId}).then(data => {
          if (data) {
            this.openaiAttemptModal(data, this.$refs.aiAttemptModal)
          }
        })

      },
      closePragyaGuideModal () {
        $('#pragyaGuideDisplayBtn').hide()
      },
      initializeLearnosityReports (data) {
        var self = this
        self.reportsApp = LearnosityReports.init(data, {
          'readyListener': function () {
            if (self.attempt.manuallyGraded) {
              self.bindReadyListener()
            }
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },
      bindReadyListener () {
        var itemReferences = []
        var report = this.reportsApp.getReport('sessionDetailByItemReport')
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference
                this.scoringObjects[itemId] = question
                itemReferences.push({'id': itemId, 'reference': reference})
                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row')).wrap('<div class="teacher_scoring"></div>')
              }
            })
          })
          if (itemReferences.length > 0) {
            var itemsActivity = {
              'state': 'review',
              'type': 'feedback',
              'items': itemReferences,
              'rendering_type': 'inline',
              'session_id': this.attempt.sessionId,
              'activity_id': this.attempt.activityId
            }
            this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
              if (data) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(data, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                  }
                })
              }
            })
          }
        })
      },
      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + question.validation.max_score
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      },
      navigateToEdit () {
        return this.$router.push({ name: 'editAssessment', params: { uuid: this.assessment.uuid } })
      },
      navigateToResult () {
        return this.$router.push({ name: 'results' })
      },
      closeAndRedirect () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'results' })
      },
      showCreate () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'createAssessment' })
      },
      async showDiagnosticTestReport () {
        this.$refs.diagnosticTestReportInfo.show()
        this.diagnosticTestReport = await this.loadDiagnosticTestReport({courseId: this.courseId, assessmentId: this.assessment.uuid })
        this.isShowDiagnosticTestReport = true
      },
      printDiagnosticTestReport () {
        const modal = document.getElementById("diagnosticReportModal")
        const cloned = modal.cloneNode(true)
        let section = document.getElementById("print")

        if (!section) {
           section  = document.createElement("div")
           section.id = "print"
           document.body.appendChild(section)
        }

        section.innerHTML = "";
        section.appendChild(cloned);
        window.print();

        setTimeout(function () {
            document.body.removeChild(section);
        }, 500)
      },
    openaiAttemptModal (resourceId, ref) {
    if(ref){
      var entityDetailInfo = {
        'entityUuid': resourceId,
        'entityType': 'LearningContent'
      }
      this.loadAIResource(entityDetailInfo).then(res => {
        this.aiResorce = res
        ref.show()
      })
     }
    },
    closeaiAttemptModal () {
      this.$refs.aiAttemptModal.hide()
    },
    closeDiagnosticTestReport () {
      this.$refs.diagnosticTestReportInfo.hide()
    },
    isPrintDisable () {
      if (this.enabledFeatures && this.enabledFeatures['disablePrint']) {
        return this.enabledFeatures['disablePrint'].enabled
      }
      return false
    },
    addPrintClass () {
      if (this.isPrintDisable()) {
        return 'no_print_win'
      } else {
        return ''
      }
    }
  }
  }
</script>

<style scoped>
.pragya_guide_container .popover {

}
.score {
    float: left;
    font-size: 23px;
    margin-top: 0px;
}
.score_txt {
    display: inline-block;
    margin-top: 8px;
    margin-left: 8px;
}
.answered {
    float: right;
}
.score_txt, .answered {
	color: rgb(148, 148, 148);
}
.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
}
.right-panel {
    overflow-y: auto;
    height: calc(100vh - 240px);
}
.icon_state, .icon_state:before {
    width:25px;
    height:25px;
}
.ic_status {
    margin-top: 8px;
    margin-right: 10px;
    float: left;
}
.toc_result_summary {
	margin-bottom: 20px;
}
.tag-box-list {
	margin-top: 5px;
    float: left;
	border-top:1px solid #e6e6e6;
  }
  .tag-box-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    float: left;
  }
  .page_content_block {
	max-height: 122px;
    overflow-y: auto;
  }
  .assessment-creation-popup .continue {
	margin-left:38px;
  }
  .result_summary {
  	float: left;
	width:100%;
  }
  .msg {
  	float: left;
    width: 100%;
    margin-top: 20px;
    text-align: justify;
  }
  .icon-warning {
 	font-size: 22px;
 	color: #ab9e00;
  }

  button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
  }
  .attempt-report-close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
  }

  .additional-btn {
	margin-top: 30px;
  }

  @media screen {
    #print {
      display: none;
     }
  }

  @media print {
   body * {
    /*visibility:hidden;*/
    }
    #print, #print * {
      visibility:visible;
    }
    #print {
      position:absolute;
      left:0;
      top:0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentDetail.vue